import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import { LyfisService } from '../../../services/lyfis.service';
import {
  LyfisPersistedUsersFilter,
  LyfisPersistedUsersGridRequest,
  LyfisPersistedUsersGridRow,
  LyfisPersistedUsersSearch,
  LyfisPersistedUsersSort
} from '../models/lyfis-persisted-users-grid.models';

interface CheckboxOptions {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-lyfis-view-users',
  templateUrl: './lyfis-view-users.component.html',
})
export class LyfisViewUsersComponent {
  LyfisPersistedUsersSort = LyfisPersistedUsersSort;
  loading = false;
  rows: LyfisPersistedUsersGridRow[] = [];
  page = 1;
  pageSize = 20;
  total = 0;

  showTesting = false;

  partnerIdCheckBoxOptions: CheckboxOptions[] = [];
  ghsBandCheckBoxOptions: CheckboxOptions[] = [];
  selectedPartnerIds: string[] = [];
  selectedBands: string[] = [];
  partnerSearch = '';

  sortKey: LyfisPersistedUsersSort =
    LyfisPersistedUsersSort.LATEST_SNAPSHOT_CREATED_AT;
  sortDirection = AnyoSortDirection.DESC;

  sortOptions = [
    {
      label: 'Latest Snapshot',
      value: LyfisPersistedUsersSort.LATEST_SNAPSHOT_CREATED_AT,
    },
    {
      label: 'Snapshot Count',
      value: LyfisPersistedUsersSort.LYFIS_SNAPSHOT_COUNT,
    },
    { label: 'Latest GHS', value: LyfisPersistedUsersSort.LATEST_GHS },
  ];

  constructor(private lyfisService: LyfisService, private router: Router) {
    void this.fetch();
  }

  fetch(): Promise<void> {
    this.loading = true;
    const req: LyfisPersistedUsersGridRequest = {
      page: this.page,
      pageSize: this.pageSize,
      export: false,
      searchQuery: {
        [LyfisPersistedUsersSearch.PARTNER_ID]: this.partnerSearch || undefined,
      },
      filters: {
        [LyfisPersistedUsersFilter.PARTNER_ID]: this.selectedPartnerIds.length
          ? this.selectedPartnerIds
          : undefined,
        [LyfisPersistedUsersFilter.LATEST_GHS_BAND]: this.selectedBands.length
          ? this.selectedBands
          : undefined,
        [LyfisPersistedUsersFilter.TEST_USERS]: [String(this.showTesting)],
      },
      sort: {
        [LyfisPersistedUsersSort.LATEST_SNAPSHOT_CREATED_AT]:
          this.sortKey === LyfisPersistedUsersSort.LATEST_SNAPSHOT_CREATED_AT
            ? this.sortDirection
            : undefined,
        [LyfisPersistedUsersSort.LYFIS_SNAPSHOT_COUNT]:
          this.sortKey === LyfisPersistedUsersSort.LYFIS_SNAPSHOT_COUNT
            ? this.sortDirection
            : undefined,
        [LyfisPersistedUsersSort.LATEST_GHS]:
          this.sortKey === LyfisPersistedUsersSort.LATEST_GHS
            ? this.sortDirection
            : undefined,
      },
    };
    return this.lyfisService
      .getLyfisPersistedUsersGrid(req)
      .toPromise()
      .then((res) => {
        this.rows = res?.data || [];
        this.total = res?.totalRecords || 0;

        this.setPartnerIdFilterData(res?.filterOptions?.partnerId);
        this.setGhsBandFilterData(res?.filterOptions?.latestGhsBand);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  setPartnerIdFilterData(options?: string[]) {
    this.partnerIdCheckBoxOptions = [];
    options?.map((data) => {
      this.partnerIdCheckBoxOptions.push({
        checked: false,
        label: data,
        value: data,
      });
    });
  }

  setGhsBandFilterData(options?: string[]) {
    this.ghsBandCheckBoxOptions = [];
    options?.map((data) => {
      this.ghsBandCheckBoxOptions.push({
        checked: false,
        label: data,
        value: data,
      });
    });
  }

  partnerIdFilterFn() {
    this.page = 1;
    void this.fetch();
  }

  partnerIdFilterChangeFn($event: string[]) {
    this.selectedPartnerIds = $event;
  }

  ghsBandFilterFn() {
    this.page = 1;
    void this.fetch();
  }

  ghsBandFilterChangeFn($event: string[]) {
    this.selectedBands = $event;
  }

  testFilterFn() {
    this.page = 1;
    void this.fetch();
  }

  clearFilter() {
    this.partnerSearch = '';
    this.selectedPartnerIds = [];
    this.selectedBands = [];
    this.showTesting = false;
    this.partnerIdCheckBoxOptions = [];
    this.ghsBandCheckBoxOptions = [];
    this.sortKey = LyfisPersistedUsersSort.LATEST_SNAPSHOT_CREATED_AT;
    this.sortDirection = AnyoSortDirection.DESC;
    this.page = 1;
    void this.fetch();
  }

  openUser(row: LyfisPersistedUsersGridRow) {
    this.router.navigate(['/lyfis/view-scores/users', row.userId, 'snapshots']);
  }

  onPageIndexChange(page: number) {
    this.page = page;
    void this.fetch();
  }

  onPageSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.page = 1;
    void this.fetch();
  }

  applyFilters() {
    this.page = 1;
    void this.fetch();
  }
}
